import React from 'react';
import config from '../config.json';

const AirIndemniteLogo = () => {
  return (
    <a
      href={'//' + config.portalUrl}
      className="no-underline w-auto float-left block"
    >
      <img
        src={config.siteLogo}
        alt="Air-Indemnite Logo"
        className="ml-12 sm:ml-0 h-15 sm:h-20 inline-block"
      />
    </a>
  );
};

export default AirIndemniteLogo;
